/**
 * Centralized business / brand configuration for B&S Services KC LLC.
 * All hard-coded brand details should pull from here.
 */

export const siteConfig = {
  name: "B&S Services KC LLC",
  shortName: "B&S Services KC",
  legalName: "B&S Services KC LLC",
  owner: "Sergio Zaldana",
  tagline: "Professional Lawn Care & Landscaping in Johnson County, KS",
  description:
    "Trusted landscaping and lawn care company in Olathe, KS serving homes and businesses across Johnson County — mowing, landscape maintenance, bed detailing, and turf applications. Available 24/7.",

  domain: "www.bsserviceskc.com",
  url: "https://www.bsserviceskc.com",

  phone: "(913) 420-3053",
  phoneHref: "tel:+19134203053",

  email: "S@bsserviceskc.com",
  emailHref: "mailto:S@bsserviceskc.com",

  address: {
    city: "Olathe",
    state: "KS",
    region: "Johnson County",
    serviceRadius: "30 miles",
  },

  hours: {
    summary: "Available 24/7",
    days: "Monday – Sunday",
    time: "Open 24 Hours",
  },

  logo: "/bs-services-kc-logo.png",
  logoImg: "/bs-services-kc-logo.webp", // optimized (256x220) for on-page rendering
  ogImage: "/bs-services-kc-logo.png",
  favicon: "/bs-services-kc-logo.png",

  social: {
    instagram: null,
    facebook: null,
    tiktok: null,
    yelp: null,
  },

  discount: {
    label: "10% Off Your Next Service",
    short: "10% Loyalty Discount",
    description:
      "Returning customers and friends of past customers save 10% on their next service. Ask us how to lock in your discount on your next visit.",
  },

  widgets: {
    chatWidgetId: "6a4c71db3d80798f75cdbbd6",
    chatLoaderSrc: "https://widgets.leadconnectorhq.com/loader.js",
    chatResourcesUrl: "https://widgets.leadconnectorhq.com/chat-widget/loader.js",

    reviewScriptSrc: "https://reputationhub.site/reputation/assets/review-widget.js",
    reviewIframeSrc:
      "https://reputationhub.site/reputation/widgets/review_widget/QZW0ulP8b5BsLljQnF4Q?widgetId=6a4ea1671bc7c4e0f0ae0f45",

    formIframeSrc: "https://link.systemic-digital.net/widget/form/GObn6QwrDwagth8Bo2xl",
    formScriptSrc: "https://link.systemic-digital.net/js/form_embed.js",
    formId: "GObn6QwrDwagth8Bo2xl",
    formName: "Website Form",
  },

  serviceAreas: [
    "Olathe, KS",
    "Overland Park, KS",
    "Leawood, KS",
    "Shawnee, KS",
    "Lenexa, KS",
    "Prairie Village, KS",
    "Johnson County, KS",
  ],
} as const;

export type SiteConfig = typeof siteConfig;
